import { createApp } from 'vue'
import App from './App.vue'
import PrimeVue from 'primevue/config'
import Tree from 'primevue/tree'
import Card from 'primevue/card'
import Button from 'primevue/button'
import Badge from 'primevue/badge'
import Tag from 'primevue/tag'
import ProgressSpinner from 'primevue/progressspinner'
import Aura from '@primevue/themes/aura'
import 'primeicons/primeicons.css'

const app = createApp(App)
app.use(PrimeVue, { 
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: false
    }
  }
})
app.component('Tree', Tree)
app.component('Card', Card)
app.component('Button', Button)
app.component('Badge', Badge)
app.component('Tag', Tag)
app.component('ProgressSpinner', ProgressSpinner)
app.mount('#app')